import { render } from "./BreadCrumbs.vue?vue&type=template&id=f7638d5c"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__